import React from 'react';

import ProfilePicForm from 'views/user/ProfilePicForm';
import BannersForm from 'views/user/BannersForm';
import UserSettingsForm from 'views/user/UserSettingsForm';

import SetoCanvasPage from 'pages/SetoCanvasPage';
import {useCurrentSession, userDesignerInfo} from 'hooks/UserHook';
import {A, Button, Title} from 'views/AppElements';
import AppUtil from 'AppUtil';


const UserSettingsPage = (props) => {
	let readOnly = false;
	let user = null;
	if(props.match.params.userId) {
		const userId = props.match.params.userId;
		user = userDesignerInfo(userId);
		readOnly = true;
	} else {
		const session = useCurrentSession();
		user = session? session.user: null;
	}
	
	const pageUrl = user? AppUtil.getDesignerURL(user): null;
	return (<SetoCanvasPage id="userSettingsPage" title="User Settings | Seto Canvas">
				<div style={{width: '50%', margin: '20px auto', 
										'@media (max-width: 500px)': {width: 'auto', padding: '20px', margin: '0'}}}>
					{
						user !== null && 
						<div>
							{pageUrl && pageUrl !== "#" &&
								<A href={pageUrl}><h2>Go To My Page</h2></A>
							}
							
							<ProfilePicForm user={user} readOnly={readOnly} />

							<UserSettingsForm user={user} readOnly={readOnly} />
							{
								user.storeName &&
								<div>
									<BannersForm bannerImages={user.bannerImages}  storeName={user.storeName} />
								</div>
							}
							
							<div>
								<Title title="Deactivate Your Account !!!" style={{textAlign: 'left'}} separatorPosition="bottom" />
								
								<Button href={"/deactivate"+(props.match.params.userId? "/"+props.match.params.userId: "")} mui='true' color='secondary' style={{width: '100%'}}>
										<i className="fa fa-trash" aria-hidden="true"></i> Deactivate
								</Button>
							</div>
						</div>
					}
					
				</div>
			</SetoCanvasPage>);
};


export default UserSettingsPage;


// WEBPACK FOOTER //
// ./src/pages/UserSettingsPage.js